var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickSearchRecentBoard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 140,
    viewBox: "0 0 262 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_32512)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 140,
    fill: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.55 171.167L239.513 22.5V184.441H86L295.55 171.167Z",
    fill: "url(#paint0_linear_1321_32512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 23.4091C23 21.5263 24.5263 20 26.4091 20H236.433C238.316 20 239.842 21.5263 239.842 23.4091V146.591C239.842 148.474 238.316 150 236.433 150H26.4091C24.5263 150 23 148.474 23 146.591V23.4091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.299,
    cy: 60.1472,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.299,
    cy: 72.8393,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.299,
    cy: 85.5317,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.299,
    cy: 98.2233,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.299,
    cy: 110.916,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.299,
    cy: 123.609,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.861,
    cy: 60.1472,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.861,
    cy: 72.8393,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.861,
    cy: 85.5317,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.861,
    cy: 98.2233,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.861,
    cy: 110.916,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.861,
    cy: 123.609,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.861,
    cy: 136.861,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.01,
    y: 54.2059,
    width: 38.0769,
    height: 11.8822,
    fill: "#00C875"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.01,
    y: 66.8989,
    width: 38.0769,
    height: 11.8822,
    fill: "#00C875"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.01,
    y: 79.5906,
    width: 38.0769,
    height: 11.8822,
    fill: "#00C875"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.01,
    y: 92.283,
    width: 38.0769,
    height: 11.8822,
    fill: "#FFCB00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.01,
    y: 104.975,
    width: 38.0769,
    height: 12.1522,
    fill: "#FFCB00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.01,
    y: 117.668,
    width: 38.0769,
    height: 12.4223,
    fill: "#FB275D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.152,
    y: 59.067,
    width: 35.3764,
    height: 3.24059,
    rx: 1.62029,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.152,
    y: 71.7593,
    width: 35.3764,
    height: 3.24059,
    rx: 1.62029,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.152,
    y: 84.4517,
    width: 35.3764,
    height: 3.24059,
    rx: 1.62029,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.152,
    y: 97.144,
    width: 35.3764,
    height: 3.24059,
    rx: 1.62029,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.152,
    y: 109.836,
    width: 35.3764,
    height: 3.24059,
    rx: 1.62029,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.152,
    y: 122.799,
    width: 35.3764,
    height: 3.24059,
    rx: 1.62029,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.152 60.6872C129.152 59.7924 129.878 59.067 130.773 59.067H158.858V62.3075H130.773C129.878 62.3075 129.152 61.5821 129.152 60.6872Z",
    fill: "#579BFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.152 73.3796C129.152 72.4847 129.878 71.7593 130.773 71.7593H145.085V74.9999H130.773C129.878 74.9999 129.152 74.2745 129.152 73.3796Z",
    fill: "#579BFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.152 86.072C129.152 85.1771 129.878 84.4517 130.773 84.4517H151.296V87.6923H130.773C129.878 87.6923 129.152 86.9668 129.152 86.072Z",
    fill: "#579BFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.152 98.7643C129.152 97.8695 129.878 97.144 130.773 97.144H140.494V100.385H130.773C129.878 100.385 129.152 99.6592 129.152 98.7643Z",
    fill: "#579BFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.152 111.457C129.152 110.562 129.878 109.836 130.773 109.836H152.647V113.077H130.773C129.878 113.077 129.152 112.352 129.152 111.457Z",
    fill: "#579BFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.152 124.419C129.152 123.524 129.878 122.799 130.773 122.799H146.976V126.039H130.773C129.878 126.039 129.152 125.314 129.152 124.419Z",
    fill: "#579BFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1749,
    y: 53.6654,
    width: 191.465,
    height: 12.9624,
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.8711,
    y: 53.497,
    width: 2.70098,
    height: 13.5049,
    fill: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1749,
    y: 66.3588,
    width: 191.465,
    height: 12.9624,
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.8711,
    y: 66.1901,
    width: 2.70098,
    height: 13.5049,
    fill: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1749,
    y: 79.0511,
    width: 191.465,
    height: 12.9624,
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.009 130.63L171.009 53.9365",
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.481 130.63L123.481 53.9365",
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.658 130.63L105.658 53.9365",
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.086 130.63L209.086 53.9365",
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.8711,
    y: 78.8824,
    width: 2.70098,
    height: 13.5049,
    fill: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1749,
    y: 91.7428,
    width: 191.465,
    height: 12.9624,
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.8711,
    y: 91.5745,
    width: 2.70098,
    height: 13.5049,
    fill: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1749,
    y: 104.436,
    width: 191.465,
    height: 12.9624,
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1749,
    y: 117.399,
    width: 191.465,
    height: 12.9624,
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.8711,
    y: 104.268,
    width: 2.70098,
    height: 13.5049,
    fill: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.8711,
    y: 117.129,
    width: 2.70098,
    height: 13.5049,
    fill: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.1963,
    y: 59.3376,
    width: 32.6759,
    height: 2.70049,
    rx: 1.35024,
    fill: "#E3E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.1963,
    y: 84.7223,
    width: 34.0262,
    height: 2.70049,
    rx: 1.35024,
    fill: "#E3E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.1963,
    y: 110.916,
    width: 23.7643,
    height: 2.70049,
    rx: 1.35024,
    fill: "#E3E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.1963,
    y: 122.529,
    width: 23.7643,
    height: 2.70049,
    rx: 1.35024,
    fill: "#E3E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.1963,
    y: 97.414,
    width: 16.743,
    height: 2.70049,
    rx: 1.35024,
    fill: "#E3E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.1963,
    y: 72.0292,
    width: 26.4648,
    height: 2.70049,
    rx: 1.35024,
    fill: "#E3E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.7292,
    y: 39,
    width: 62.8289,
    height: 3.4905,
    rx: 1.74525,
    fill: "#E3E6F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.299,
    cy: 136.852,
    r: 4.86088,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.01,
    y: 130.91,
    width: 38.0769,
    height: 11.8822,
    fill: "#00C875"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.152,
    y: 135.772,
    width: 35.3764,
    height: 3.24059,
    rx: 1.62029,
    fill: "#E2E6F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.152 137.392C129.152 136.497 129.878 135.772 130.773 135.772H158.858V139.012H130.773C129.878 139.012 129.152 138.287 129.152 137.392Z",
    fill: "#579BFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1749,
    y: 130.37,
    width: 191.465,
    height: 12.9624,
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.8711,
    y: 130.202,
    width: 2.70098,
    height: 13.5049,
    fill: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.009 207.335L171.009 130.641",
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.481 207.335L123.481 130.641",
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.658 207.335L105.658 130.641",
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.086 207.335L209.086 130.641",
    stroke: "#E2E6F3",
    strokeWidth: 0.540098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.1963,
    y: 136.042,
    width: 32.6759,
    height: 2.70049,
    rx: 1.35024,
    fill: "#E3E6F3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_1321_32512)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 103,
    width: 261,
    height: 72,
    fill: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_1321_32512)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 132,
    width: 261,
    height: 34,
    fill: "#6C6CFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1321_32512",
    x: -33,
    y: 69,
    width: 329,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17,
    result: "effect1_foregroundBlur_1321_32512"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1321_32512",
    x: -33,
    y: 98,
    width: 329,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17,
    result: "effect1_foregroundBlur_1321_32512"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1321_32512",
    x1: 191,
    y1: 36.9676,
    x2: 264.041,
    y2: 136.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F1048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1048",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_32512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 140,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickSearchRecentBoard);
export default __webpack_public_path__ + "static/media/quick_search_recent_board.6f9409e2cfe89b36b09c7ae8df20d61a.svg";
export { ForwardRef as ReactComponent };